// Genereerd bestand - NIET BEWERKEN!
// WEL inchecken in Git!

export enum Functionalities {
    AccessAllCustomers = 'accessAllCustomers',
    Adresses = 'adresses',
    AfasAuth = 'afasAuth',
    AfasInvoices = 'afasInvoices',
    Ai = 'ai',
    AiReports = 'aiReports',
    Airtable = 'airtable',
    AllProjects = 'allProjects',
    ApplyRestrictedRoles = 'applyRestrictedRoles',
    ArticleManagement = 'articleManagement',
    AsphaltManagement = 'asphaltManagement',
    Chats = 'chats',
    ChatsManagement = 'chatsManagement',
    Checklist = 'checklist',
    ChecklistManagement = 'checklistManagement',
    ChecklistSignOff = 'checklistSignOff',
    ClientManagement = 'clientManagement',
    CodaltAppLogs = 'codaltAppLogs',
    CodaltFailedJobs = 'codaltFailedJobs',
    CodaltLogViewer = 'codaltLogViewer',
    CodaltMode = 'codaltMode',
    Common = 'common',
    CommonHourCheck = 'commonHourCheck',
    CommonOffice = 'commonOffice',
    CustomerManagement = 'customerManagement',
    CustomerProjectsManage = 'customerProjectsManage',
    CustomerProjectsParticipate = 'customerProjectsParticipate',
    CustomerProjectsSubscribe = 'customerProjectsSubscribe',
    DayreportsMutate = 'dayreportsMutate',
    DeclarationManagement = 'declarationManagement',
    DirkUserTakeover = 'dirkUserTakeover',
    EmployeePlanningManagement = 'employeePlanningManagement',
    EmployeePlanningRead = 'employeePlanningRead',
    EntitiesManagement = 'entitiesManagement',
    ExecutorPlanning = 'executorPlanning',
    ExecutorPlanningRead = 'executorPlanningRead',
    External = 'external',
    GeoManage = 'geoManage',
    GeoRead = 'geoRead',
    GeoRestricted = 'geoRestricted',
    GeoTransferWorkareas = 'geoTransferWorkareas',
    HiringManagement = 'hiringManagement',
    HourCheck = 'hourCheck',
    HourCheckRestricted = 'hourCheckRestricted',
    Hours = 'hours',
    HoursExtended = 'hoursExtended',
    HourTimeEdit = 'hourTimeEdit',
    Leave = 'leave',
    LeaveManagement = 'leaveManagement',
    MaterialsManagement = 'materialsManagement',
    News = 'news',
    NewsManagement = 'newsManagement',
    OwnHours = 'ownHours',
    PeriodSettlementExecution = 'periodSettlementExecution',
    Plannable = 'plannable',
    PlanningOverview = 'planningOverview',
    PlanningOverviewManagement = 'planningOverviewManagement',
    PlanningOverviewOwn = 'planningOverviewOwn',
    ProjectManagement = 'projectManagement',
    ReadPeriodSettlement = 'readPeriodSettlement',
    Report = 'report',
    RightsMatrix = 'rightsMatrix',
    Settle = 'settle',
    Staffing = 'staffing',
    Tickets = 'tickets',
    TicketsKamDetails = 'ticketsKamDetails',
    TicketsManagement = 'ticketsManagement',
    Timeline = 'timeline',
    TimelineManagement = 'timelineManagement',
    Toolbox = 'toolbox',
    ToolboxManagement = 'toolboxManagement',
    Transportplanning = 'transportplanning',
    TransportplanningAlwaysRead = 'transportplanningAlwaysRead',
    TransportplanningManagement = 'transportplanningManagement',
    TransportPlanningReadOnly = 'transportPlanningReadOnly',
    UserManagement = 'userManagement',
    UserTakeover = 'userTakeover',
    VkmManagement = 'vkmManagement',
    VkmRead = 'vkmRead',
    VkmReadWithPrice = 'vkmReadWithPrice',
    VkmWorkorderExecution = 'vkmWorkorderExecution',
    Weekreports = 'weekreports',
    Wfs = 'wfs',
}
